module.exports = __webpack_public_path__ + "static/media/dungeon_floor_ne.3d942046.png";